import { iconFactory } from '../iconFactory'

export const Add = iconFactory(
  'Add',
  ({ fill }) => (
    <path
      d="M15.8334 10.8332H10.8334V15.8332H9.16675V10.8332H4.16675V9.1665H9.16675V4.1665H10.8334V9.1665H15.8334V10.8332Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 20 20', height: '20px', width: '20px' },
)
